import axios from "axios"

export const getStartupData = () => axios.get("/api/v1/startup")
